import { useState, useEffect } from "react";

function NotFound404() {
  const [hue, setHue] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setHue(prev => (prev + 1) % 360); // 0–360 = espectro completo
    }, 50); // velocidad

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="App d-flex justify-content-center bg-dark text-white">
        <div className="mb-4 mt-4 text-center">
          <h1>Vaya, vaya, vaya....</h1>
          <br />
          <h2>Una de dos... o te has perdido 🗺📍❓ o tu gato 🐱 estaba jugando con el teclado</h2>
          <br />
          <h3>Por aqui dejamos un botón por si es el gato que intente darle click</h3>
          <br />
          <p>⬇</p>
          <button
            type="button"
            className="my-4 btn"
            style={{
              backgroundColor: `hsl(${hue}, 100%, 50%)`,
              borderColor: `hsl(${hue}, 100%, 50%)`,
              color: "white"
            }}
            onClick={() => { window.location.href = "/" }}
          >
            <>
            🐭🐭🐭🐭🐭🐭
            <br/>
            🐭🐭🐭🐭🐭🐭
            <br/>
            🐭🐭🐭🐭🐭🐭
            <br/>
            🐭🐭🐭🐭🐭🐭
            <br/>
            🐭🐭🐭🐭🐭🐭
            <br/>
            🐭🐭🐭🐭🐭🐭
            </>
          </button>
          <br />
          *Postdata: página no apta para cierto gato azul 🔵 
          <br/>
          😝
        </div>
      </div>
      <title>Error 404: Página no encontrada</title>
    </>
  );
}

export default NotFound404;
